var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pack",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBD40"
    },
    d: "M72,264h144v112H72V264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBD40"
    },
    d: "M264,264h144v112H264V264z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9686A"
    },
    d: "M48,376h384c22.091,0,40,17.909,40,40l0,0c0,22.091-17.909,40-40,40H48c-22.091,0-40-17.909-40-40 l0,0C8,393.909,25.909,376,48,376z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCF05A"
    },
    cx: 48,
    cy: 416,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCF05A"
    },
    cx: 112,
    cy: 416,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCF05A"
    },
    cx: 176,
    cy: 416,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCF05A"
    },
    cx: 240,
    cy: 416,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCF05A"
    },
    cx: 304,
    cy: 416,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCF05A"
    },
    cx: 368,
    cy: 416,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCF05A"
    },
    cx: 432,
    cy: 416,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF05A"
    },
    d: "M120,264h48v48h-48V264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF05A"
    },
    d: "M312,264h48v48h-48V264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF05A"
    },
    d: "M192,352h-16c-4.418,0-8-3.582-8-8s3.582-8,8-8h16c4.418,0,8,3.582,8,8S196.418,352,192,352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF05A"
    },
    d: "M384,352h-16c-4.418,0-8-3.582-8-8s3.582-8,8-8h16c4.418,0,8,3.582,8,8S388.418,352,384,352z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B11E48"
    },
    d: "M336,72h48v192h-48V72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14E54"
    },
    d: "M128,24h256v48H128V24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14E54"
    },
    d: "M112,224c-4.418,0-8-3.582-8-8v-32c-0.001-2.43,1.103-4.729,3-6.248l40-32 c3.451-2.761,8.487-2.203,11.248,1.248c2.761,3.451,2.203,8.487-1.248,11.248l-37,29.592V216C120,220.418,116.418,224,112,224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14E54"
    },
    d: "M240,224c-4.418,0-8-3.582-8-8v-28.16l-37-29.6c-3.451-2.761-4.009-7.797-1.248-11.248 s7.797-4.009,11.248-1.248l40,32c1.899,1.521,3.003,3.823,3,6.256v32C248,220.418,244.418,224,240,224L240,224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14E54"
    },
    d: "M176,136c-4.418,0-8-3.582-8-8V72c0-4.418,3.582-8,8-8s8,3.582,8,8v56 C184,132.418,180.418,136,176,136z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF05A"
    },
    d: "M160,24h32v48h-32V24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D8D9C"
    },
    d: "M176,184c-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S193.673,184,176,184z M176,136 c-8.837,0-16,7.163-16,16s7.163,16,16,16s16-7.163,16-16S184.837,136,176,136z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432,368h-16V264c0-4.418-3.582-8-8-8h-16V24c0-4.418-3.582-8-8-8H128c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h40 v41.136c-12.553,3.272-21.874,13.82-23.576,26.68L107,177.752c-1.897,1.519-3.001,3.818-3,6.248v32c0,4.418,3.582,8,8,8 c4.418,0,8-3.582,8-8v-28.16l27.344-21.872c7.594,15.826,26.58,22.5,42.406,14.906c6.52-3.128,11.778-8.386,14.906-14.906 L232,187.84V216c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8v-32c0.001-2.43-1.103-4.729-3-6.248l-37.424-29.936 c-1.702-12.86-11.023-23.408-23.576-26.68V80h144v176h-64c-4.418,0-8,3.582-8,8v104h-32V264c0-4.418-3.582-8-8-8H72 c-4.418,0-8,3.582-8,8v104H48c-26.51,0-48,21.49-48,48s21.49,48,48,48h384c26.51,0,48-21.49,48-48S458.51,368,432,368z M192,152 c0,8.837-7.163,16-16,16s-16-7.163-16-16s7.163-16,16-16S192,143.163,192,152z M376,64H200V32h176V64z M136,32h16v32h-16V32z M168,64V32h16v32H168z M344,80h32v176h-32V80z M352,272v32h-32v-32H352z M272,272h32v40c0,4.418,3.582,8,8,8h48 c4.418,0,8-3.582,8-8v-40h32v96H272V272z M160,272v32h-32v-32H160z M80,272h32v40c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-40 h32v96H80V272z M432,448H48c-17.673,0-32-14.327-32-32s14.327-32,32-32h384c17.673,0,32,14.327,32,32S449.673,448,432,448z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48,392c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S61.255,392,48,392z M48,424c-4.418,0-8-3.582-8-8 s3.582-8,8-8s8,3.582,8,8S52.418,424,48,424z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112,392c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S125.255,392,112,392z M112,424c-4.418,0-8-3.582-8-8 s3.582-8,8-8c4.418,0,8,3.582,8,8S116.418,424,112,424z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176,392c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S189.255,392,176,392z M176,424c-4.418,0-8-3.582-8-8 s3.582-8,8-8s8,3.582,8,8S180.418,424,176,424z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240,392c-13.255,0-24,10.745-24,24s10.745,24,24,24c13.255,0,24-10.745,24-24S253.255,392,240,392z M240,424 c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S244.418,424,240,424z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304,392c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S317.255,392,304,392z M304,424c-4.418,0-8-3.582-8-8 s3.582-8,8-8s8,3.582,8,8S308.418,424,304,424z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M368,392c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S381.255,392,368,392z M368,424c-4.418,0-8-3.582-8-8 s3.582-8,8-8s8,3.582,8,8S372.418,424,368,424z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M432,392c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S445.255,392,432,392z M432,424c-4.418,0-8-3.582-8-8 s3.582-8,8-8s8,3.582,8,8S436.418,424,432,424z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192,336h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S196.418,336,192,336z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M384,336h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S388.418,336,384,336z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack);
export default __webpack_public_path__ + "static/media/pack.14b848a68aa7b2e98044b19e72c881c5.svg";
export { ForwardRef as ReactComponent };